import React from 'react'
import { Card, P, RenderControl, Span, styled } from '@fareye/ui'
import { displayTime } from '../../../utility/function'
import { isEmpty } from '@fareye/utils'
import { useTranslation } from '@fareye/common'
const exceptionData = [
  {
    id: 1,
    type: 'ParcelExceptionAlertSubscription',
    createdAt: '',
    locationName: '',
    carrierStatus: 'CLOSED',
    invoiceNo: '93357706190_7016122911_FUKUYAMA',
    lrNo: '93357706190',
    driver: '',
    origin: 'DC JP KOBE',
    destination: '',
    transporter: 'FUKUYAMA',
    material: '',
    vehicleNo: '',
    coords: { lat: '', lng: '' },
    referenceNumber: '93357706190_7016122911_FUKUYAMA'
  },
  {
    id: 2,
    type: 'ParcelOutForDeliveryAlertSubscription',
    createdAt: '',
    locationName: '',
    carrierStatus: 'OutForDelivery',
    invoiceNo: '93357706190_7016122911_FUKUYAMA',
    lrNo: '93357706190',
    driver: '',
    origin: 'DC JP KOBE',
    destination: '',
    transporter: 'FUKUYAMA',
    material: '',
    vehicleNo: '',
    coords: { lat: '', lng: '' },
    referenceNumber: '93357706190_7016122911_FUKUYAMA'
  }
]
const THead = styled.thead`
  color: #727272;
  text-align: left;
`
const Td = styled.td`
  padding: 10px 0px;
  font-size: 14px;
  color: #727272;
`
export default function Exception(data: any) {
  const { t } = useTranslation()
  const exceptions = isEmpty(data?.exceptions) ? [] : data?.exceptions
  const initialState = {
    isSuccess: true,
    isError: false,
    data: exceptions,
    isLoading: false,
    message: isEmpty(exceptions)
      ? `${t('No Exceptions encountered for this parcel')}..`
      : ''
  }
  return (
    <Card style={{ border: '0px' }} bodyStyle={{ padding: '18px' }} variant="m">
      <P variant="h5" style={{ marginBottom: '18px', marginTop: '5px' }}>
        {`${t('Exceptions')} (${exceptions.length})`}
      </P>
      <RenderControl state={initialState}>
        <table>
          <THead>
            <th>{t('Type')}</th>
            <th>{t('Date & Time')}</th>
            <th>{t('Location')}</th>
          </THead>
          <tbody>
            {exceptions.map((ele: any) => {
              return (
                <tr>
                  <Td>
                    <Span variant="ellipsis">{ele.type}</Span>
                  </Td>
                  <Td>
                    <Span variant="ellipsis">
                      {ele.createdAt ? displayTime(ele.createdAt) : '-'}
                    </Span>
                  </Td>
                  <Td>
                    <Span variant="ellipsis">{ele.locationName}</Span>
                  </Td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </RenderControl>
    </Card>
  )
}
